import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Grid } from '@chakra-ui/react';
import { hasValue, useT } from '@progress-fe/core';
import { VirtualTable } from '../../../../tables';
import { Input, Select } from '../../../../inputs';
const LumpComponentsFC = ({ components, tableSx }) => {
    const [query, setQuery] = useState('');
    const [selectedModel, setSelectedModel] = useState('');
    const { t } = useT();
    const modelsOptions = useMemo(() => {
        const options = [{ value: '', label: 'Все модели' }];
        const uniqueModels = [...new Set(components.map((c) => c.model).filter((m) => hasValue(m)))];
        uniqueModels.forEach((um) => options.push({ value: um, label: um }));
        return options;
    }, [components]);
    const columns = [
        { name: t('fields.name'), align: 'left' },
        { name: t('fields.formula'), align: 'left' },
        { name: t('fields.model'), align: 'left' }
    ];
    const filteredComponentsByName = components.filter((opt) => opt.name.toLowerCase().includes(query.toLowerCase()) ||
        opt.formula?.toLowerCase().includes(query.toLowerCase()));
    const filteredComponentsByNameAndModel = filteredComponentsByName.filter((opt) => hasValue(selectedModel) ? selectedModel === opt.model : true);
    const rows = filteredComponentsByNameAndModel.map((opt) => ({
        key: opt.uuid,
        values: [opt.name, opt.formula || '-', opt.model || '-'],
        isDisabled: false
    }));
    return (_jsxs(Grid, { templateRows: "auto 1fr", gap: "8px", children: [_jsxs(Grid, { gridTemplateColumns: "1fr 1fr", gap: "8px", children: [_jsx(Input, { name: "search", size: "xs", variant: "outline", value: query, placeholder: t('actions.search'), onChange: setQuery }), _jsx(Select, { name: "chemical_model", options: modelsOptions, value: modelsOptions.find((opt) => opt.value === selectedModel), onChange: (option) => setSelectedModel(option.value) })] }), _jsx(VirtualTable, { rows: rows, columns: columns, noItemsTitle: t('components.no'), tableSx: tableSx })] }));
};
export const LumpComponents = observer(LumpComponentsFC);
//# sourceMappingURL=LumpComponents.js.map